// extracted by mini-css-extract-plugin
export default {"FeaturedCardWrpper":"Featured_FeaturedCardWrpper__wkRLU","cardCstm":"Featured_cardCstm__lq306"};